module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-requests"
  }, [_c('module-spinner', {
    attrs: {
      "active": _vm.loading && _vm.reviewRequestsTotal === 0,
      "floating": true
    }
  }), _vm._v(" "), (_vm.userIsRole([1])) ? _c('module-button', {
    staticClass: "mt0 mb",
    attrs: {
      "button": "primary",
      "size": "m",
      "label": "Start New Request",
      "link": "request"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.content.title) ? _c('h1', {
    class: [
      "h3",
      {
        'mt0': !_vm.userIsRole([1, 2]),
      }
    ],
    domProps: {
      "innerHTML": _vm._s(_vm.content.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.content.copy) ? _c('p', {
    staticClass: "p",
    domProps: {
      "innerHTML": _vm._s(_vm.content.copy)
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.reviewRequestsTotal > 0) ? _c('div', {
    key: "requests-table"
  }, [_c('module-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.reviewRequests.results,
      "row-click": true,
      "row-title": _vm.getRowTitle
    },
    on: {
      "row-click": _vm.onRowClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-requests__more"
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Showing "), _c('strong', [_vm._v(_vm._s(_vm.reviewRequestsLength))]), _vm._v(" of "), _c('strong', [_vm._v(_vm._s(_vm.reviewRequestsTotal))]), _vm._v(" Results")]), _vm._v(" "), (_vm.reviewRequests.next) ? _c('module-button', {
    attrs: {
      "button": "primary",
      "label": "Load more",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.getNextPage($event)
      }
    }
  }) : _vm._e()], 1)], 1) : (_vm.reviewRequestsTotal === 0 && !_vm.loading && _vm.userIsRole([1])) ? _c('div', {
    key: "no-requests"
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("You have no requests. Please request a new "), _c('module-link', {
    attrs: {
      "link": "request",
      "label": "review here",
      "color": "secondary"
    }
  }), _vm._v(".")], 1)]) : (_vm.reviewRequestsTotal === 0 && !_vm.loading && _vm.userIsRole([2, 3])) ? _c('p', {
    staticClass: "fw-bold"
  }, [_vm._v("No current X-Ray upload requests")]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7b33b16"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/dashboard/Requests.vue
// module id = 339
// module chunks = 0